@if (mostrar()) {
  <div class="cinta-produccion" role="alert" aria-label="Estás en producción">
    <span class="cinta-produccion__texto">⚠ PRODUCCIÓN · ESTÁS EN PRODUCCIÓN · PRODUCCIÓN ⚠</span>
  </div>
}
